<div class="bg-cover bg-center bg-no-repeat item-center text-white md:h-[500px] p-4 md:p-24 bg-gray-500" [ngStyle]="{'background-image': 'url(' + tenant.getImg(tenant.GIVEAWAYS) + ')'}">
	<div class="md:max-w-[50%]">
		<p class="text-xl md:text-md font-bold mb-6 uppercase">{{this.loadeddata['Name']}} PREMIUM GIVEAWAYS</p>
		<h2 class="text-4xl md:text-5xl font-bold text-left text-white mb-4">
			Want to experience game day like never before?
		</h2>
		<p class="text-2xl">
			{{this.loadeddata['Name']}} subscribers get the chance to win exclusive on-field access
			at {{this.loadeddata['StadiumName']}} and beyond!
		</p>
    <button *ngIf ="this.loadeddata.ActiveGiveawayEvent" class="btn md:btn-wide btn-block btn-white rounded-md font-bold text-lg px-6 md:pt-[1rem] md:pb-[2.5rem] mt-4" (click)="trackevent('studentplans.why')" routerLink="/{{this.tenant.getName()}}/giveawayentry/{{this.loadeddata.ActiveGiveawayEvent}}">
		 <span [ngStyle]="{ color: loadeddata?.PrimaryColor }">Enter Now!</span></button>
	</div>
</div>